module.exports = __webpack_public_path__ + "static/img/ll.3b42cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/ll.jpg
// module id = ZEoa
// module chunks = 1